import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import * as Constants from '../../../../core/constants';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
//import { getClassLibrary, isLibraryLoading, libraryLoaded, classQuery, classBase } from '../../../../modules/Class';
import { getActivityLibrary, isLibraryLoading, libraryLoaded, activityQuery, activityBase } from '../../../../modules/Activity';
import searchController from '../../../../components/hoc/searchController';
import SearchBar from '../../../../components/organism/SearchBar';
import CardGrid from '../../../organism/CardGrid';
import InfoCard from '../../Cards/InfoCard';
import Drawer from '@material-ui/core/Drawer';
import { createSelects, displayTags } from '../../../../utils';
import { toast } from 'react-toastify';

const ENT_PLACEHOLDER = require('../../../../assets/entity_placeholder.jpg').default;

const CardGridStyled = styled(CardGrid)`

`
const Container = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  width: 700px;
`
const Scrollable = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
`

const DrawerStyled = styled(Drawer)`
  
`

const ActivitySearch = searchController(SearchBar, 'activities', { params: { page_size: Constants.PER_PAGE_DEFAULT } });

class ChooseActivityModal extends React.Component {
  constructor(props){
    super(props);
    this.selects = [];
    this.state = {
      input: '',
      page: Constants.START_PAGE_DEFAULT,
      perPage: Constants.PER_PAGE_DEFAULT,
      gotoNext: false,
      viewModalOpen: false,
    }
  }

  async componentDidMount() {
    /*
    const initialSelect = createSelect('Status', 'Choose a status', 'filter', [
      {
        label: 'Completed',
        value: 'valid'
      },
      {
        label: 'Incomplete',
        value: 'invalid'
      },
    ], false);
    */
    this.selects = []; // [initialSelect];
    this.retrieveActivities();
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.open && this.props.open) {
      this.retrieveActivities();
    }
  }

  retrieveActivities = async () => {
    const { getActivityLibrary, activityBase } = this.props;
    const { page, perPage } = this.state;

    try {
      activityBase();
      await getActivityLibrary({ params: { page, page_size: perPage } });
    } catch(e) {
      console.log('component: ',this,e.message);
      toast.error(e.message);
    }
  }

  onChange = event => this.setState({ input: event.target.value });

  onSelectActivity = (item) => {
    const { onSubmit, onClose } = this.props;

    onSubmit(item);
    onClose();
  }

  openViewModal = (item = null) => this.setState({ viewModalOpen: true });

  closeViewModal = () => this.setState({ viewModalOpen: false });

  renderCard = (item, index) => {
    return (
      <InfoCard
        key={`${index}-${item.name}`}
        image={item.image ? item.image.url : ENT_PLACEHOLDER}
        header={item.name}
        subtext1={item.activity_type}
        cardButtonIcon={this.props.cardButtonIcon}
        onCardClick={() => this.openViewModal(item)}
        onClick={() => this.onSelectActivity(item)}
      />
    )
  }

  onNext = () => {
    const { activityState } = this.props;
    const { totalCount, activities } = activityState;
    if (activities && totalCount && activities.length < totalCount && !activityState.isLoading) {
      this.setState({gotoNext: true})
    }
  }

  libraryDidLoad = (results, count, query) => {
    this.props.libraryLoaded(results, count, query);
    this.setState({gotoNext: false});
  }

  startQuery = () => {
    const { activityQuery, activityState } = this.props;
    if (!activityState.isLoading) {
      activityQuery();
    }
  }

  render() {
    const {
      anchor,
      activityState,
      isLibraryLoading,
      onClose,
      open,
      resourceState
    } = this.props;
    const { perPage, gotoNext, viewModalOpen } = this.state;

    const includedSelects = {
      cat: true,
      mg: true,
      il: true,
      eq: false,
      fg: false,
    };

    return (
      <DrawerStyled anchor={anchor} onClose={onClose} open={open}>
        <Container>
          <ActivitySearch
            getter={isLibraryLoading}
            setter={this.libraryDidLoad}
            base={this.startQuery}
            gotoNext={gotoNext}
            perPage={perPage}
          />
          <Scrollable>
            <CardGridStyled
              data={activityState.activities}
              renderItem={(item,index) => this.renderCard(item,index)}
              nextPage={this.onNext}
              isLoading={activityState.isLoading}
              xs={12}
              sm={12}
              md={12}
              lg={6}
              xl={6}
            />
          </Scrollable>
        </Container>
      </DrawerStyled>
    );
  }

}

ChooseActivityModal.propTypes = {
  header: PropTypes.string,
  onSubmit: PropTypes.func,
  onClick: PropTypes.func,
  onClose: PropTypes.func,
  cardButtonIcon: PropTypes.string,
};

ChooseActivityModal.defaultProps = {
}

function mapStateToProps(state) {
  return {
    activityState: state.activityState,
    resourceState: state.resourceState
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    getActivityLibrary: getActivityLibrary,
    isLibraryLoading: isLibraryLoading,
    libraryLoaded: libraryLoaded,
    activityQuery: activityQuery,
    activityBase: activityBase,
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(ChooseActivityModal);
